import { View } from 'dripsy';
import * as React from 'react';
const FormContext = React.createContext({});
export const useFormControl = () => React.useContext(FormContext);
export const FormControl = React.forwardRef(({ id, isDisabled, isRequired, isInvalid, children }, forwardedRef) => {
    const passedProps = {
        isDisabled,
        isRequired,
        isInvalid,
    };
    return (React.createElement(View, { nativeID: id, ref: forwardedRef },
        React.createElement(FormContext.Provider, { value: passedProps }, React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, passedProps);
            }
            return child;
        }))));
});
FormControl.displayName = 'FormControl';
//# sourceMappingURL=FormControl.js.map